import { T_PRICING_PAGE_CONSTANTS } from './TYPES'

const EN_PRICING_PAGE_CONSTANTS: T_PRICING_PAGE_CONSTANTS = {
  TITLE: 'Subcription Plans for Children',
  DESCRIPTION: [
    {
      label: 'All-Inclusive Budget Plans: Perfect for Every Need!'
    },
    {
      newLine: true,
      label: 'Adults can use the platform for Free while children enjoy a'
    },
    {
      label: 'Free Trial period of 15 days!',
      color: true
    }
  ]
}

export default EN_PRICING_PAGE_CONSTANTS
